import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useOptionalVoiceAssistant } from '../contexts/VoiceAssistantProvider';

/**
 * Global voice recording cleanup hook.
 * Navigation discards capture (never submits).
 */
export const useVoiceRecordingCleanup = () => {
  const location = useLocation();
  const previousLocation = useRef<string>('');
  const voice = useOptionalVoiceAssistant();

  useEffect(() => {
    if (previousLocation.current && previousLocation.current !== location.pathname) {
      console.log('Navigation detected, discarding voice capture...');

      voice?.cancelCapture();

      const cleanupEvent = new CustomEvent('voice-recording-cleanup', {
        detail: {
          reason: 'navigation',
          disposition: 'discard',
          from: previousLocation.current,
          to: location.pathname,
        },
      });
      window.dispatchEvent(cleanupEvent);
      window.dispatchEvent(
        new CustomEvent('stopVoiceInput', {
          detail: { disposition: 'discard', reason: 'navigation' },
        })
      );
    }

    previousLocation.current = location.pathname;
  }, [location.pathname, voice]);
};

export default useVoiceRecordingCleanup;
